<template>
  <div>
    <el-dialog
    title="手动触发"
    :append-to-body="true"
    :before-close="closeView"
     :close-on-click-modal="false"
     class="addTaskView"
      :visible.sync="showManual"
      width="550px">
      <!-- <span slot="title" class="dialog-footer">
        <span>手动触发</span>
      </span> -->
      <el-form  ref="ruleForm"  :rules="rules" :model="form">
        <el-row>
           <span class="star">*</span> 手动执行的日期
          </el-row>
        <el-form-item label="" prop="manualTime">
           <el-date-picker
           :picker-options="pickerOption"
           style="width:100%"
            v-model="form.manualTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
<!-- 按小时/f分钟统计才显示 -->
        <el-form-item v-if="taskDetail.way.toString() === '2' || taskDetail.way.toString() === '3'" prop="time">
          <el-row>
            <span class="star">*</span>
            具体时间
          </el-row>
          <!-- <el-select v-model="form.hour"  placeholder="请选择">
            <el-option
              v-for="item in hourList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select> -->
          <el-cascader
           style="width:100%"
            separator=""
            v-model="form.time"
            :options="hourList"
            :props="{ expandTrigger: 'hover' }">
          </el-cascader>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="addManual" size="small">确 定</el-button>
        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { taskTimerManual, timerCheck } from '@/api/dataStatistics'

import { dateFormat } from '@/assets/js/tools'
export default {
  components: {
  },
  props: {
    showManual: {
      tyhpe: Boolean
    },
    taskDetail: {
      type: Object || null
    }
  },
  data: function () {
    var validateTime = (rule, value, callback) => {
      if ((this.taskDetail.way.toString() === '2' || this.taskDetail.way.toString() === '3') && this.form.time === '') {
        callback(new Error('请选择具体时间'))
      } else {
        callback()
      }
    }
    return {
      form: {
        manualTime: '',
        time: ''
      },
      rules: {
        manualTime: [
          { required: true, message: '请输入手动执行的日期', trigger: 'change' }
        ],
        time: [
          { validator: validateTime, trigger: 'change' }
        ]
      },
      pickerOption: {
        disabledDate (time) {
          const limmitDate = new Date()
          return time.getTime() < limmitDate.getTime()
        }
      }
    }
  },
  computed: {
    // 整点时间
    hourList () {
      let i = 0
      const list = []
      const children = []
      while (i < 60) {
        children.push(
          { label: `${i}分`, value: i.toString() }
        )
        i++
      }
      if (this.taskDetail.way.toString() === '2') { // 按照小时统计
        // i = 0 改成了1
        i = 0
        while (i < 24) {
          list.push(
            { label: `${i}点`, value: i }
          )
          i++
        }
      } else if (this.taskDetail.way.toString() === '3') { // 按照分钟统计
        // i = 0
        // while (i < 60) {
        //   children.push(
        //     { label: `${i}分`, value: i }
        //   )
        //   i++
        // }
        i = 0
        while (i < 24) {
          list.push(
            { label: `${i}点`, value: i, children: children }
          )
          i++
        }
      }
      console.log('list', list)
      return list
    }
  },
  methods: {
    closeView () {
      this.$emit('closeView')
    },
    confirmAdd (params) {
      taskTimerManual(params).then(res => {
        res = res.data
        console.log('手动触发添加返回：', res)
        if (res.code === 200) {
          this.$emit('message', '手动触发设置成功')
          this.closeView()
        }
      })
    },
    addManual () {
      this.$refs.ruleForm.validate((valid) => {
        // 复制的页面的旧逻辑
        if (valid) {
          const params = {
            taskId: this.taskDetail.taskId,
            manualTime: dateFormat(this.form.manualTime),
            hour: this.form.time[0] ? this.form.time[0] : '',
            minute: this.form.time[1] ? this.form.time[1] : ''
          }
          console.log('请求的params：', params)
          timerCheck(params).then(res => {
            res = res.data
            console.log('检查返回：', res)
            if (res.code === 200) {
              if (res.data.yes) { // 存在数据，需要弹框覆盖提示确认
                const confirmText = '任务在该时间段有统计数据,确定删除重新统计？'
                // const that = this
                this.$confirm(confirmText, '提示', {
                  closeOnClickModal: false
                }).then(() => {
                  // that.confirmAdd(params)
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  })
                })
              } else {
                this.confirmAdd(params)
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scope>
.addTaskView{
  .star{
       color:#d93026;
    }
    .el-row{
      margin-bottom: 10px;
    }
  }
</style>
